import styled from "styled-components";

export const UltAlt = styled.div`
    font-size: 10px;
    width: 100%;
    text-align: right;
`